const links = [
  { id: 'search', label: 'Search By Code', icon: 'bi-search', matches: ['search', 'detail'] },
  { id: 'users', label: 'User Management', icon: 'bi-people', adminOnly: true },
  { id: 'reports', label: 'Reports', icon: 'bi-clipboard-data', adminOnly: true },
];

export const AdminNavLinks = ({ activeRoute, currentUser, onNavigate }) => (
  <ul className="navbar-nav admin-nav-links">
    {links
      .filter((link) => !link.adminOnly || currentUser.role === 'admin')
      .map((link) => (
        <li className="nav-item mb-1" key={link.id}>
          <button
            className={isActive(link, activeRoute) ? 'nav-link active btn btn-link' : 'nav-link btn btn-link'}
            type="button"
            onClick={() => onNavigate(link.id)}
          >
            <i className={`bi ${link.icon} me-2`} />
            {link.label}
          </button>
        </li>
      ))}
  </ul>
);

function isActive(link, activeRoute) {
  return (link.matches || [link.id]).includes(activeRoute);
}
